<template>
  <config-pro-plus-base :show-full-comparison-dialog="showFullComparisonDialog" show-plan-details>
    <template #config>
      <config-us :show-full-comparison-dialog="showFullComparisonDialog" :show-explore-c-t-a="true" />
    </template>
  </config-pro-plus-base>
</template>

<script>
import ConfigUs from './config-us';
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';
import ConfigUsNext from './config-us-next.vue'
import { pageConfig } from '@/common/service/page-config';

const isPreviousCase = !!pageConfig.init_categories;

export default {
  components: { ConfigProPlusBase, ConfigUs: isPreviousCase ? ConfigUsNext : ConfigUs },
  mixins: [ConfigMixin],
};
</script>
